import React from "react";
import {MessageWithMetadata} from "../../../../types";

export type GPTMeta = MessageWithMetadata & {isStreaming?: boolean};

export const GPTMetaContext = React.createContext<GPTMeta | undefined>(
    undefined
);
